import cloneDeep from 'lodash/cloneDeep';
import difference from '../../../../utils/difference';

export class UserPopupChangeTracker {

    constructor() {
        this.controller = {};
    }

    register(controller) {
        this.controller = controller;
        this.setOriginals();
    }

    undo() {
        this.controller.user = cloneDeep(this.origUser);
        this.controller.selectedRole = this.origRole;
        this.controller.onSelectedRole();
    }

    noChanges() {
        return difference(this.origUser, this.controller.user) === 0 && this.controller.selectedRole === this.origRole;
    }

    refresh() {
        this.setOriginals();
    }

    setOriginals() {
        this.origUser = cloneDeep(this.controller.user);
        this.origRole = this.controller.selectedRole;
    }
}


// WEBPACK FOOTER //
// ./components/popups/user-popup/user-popup-change-tracker.js